/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    TextField,
} from '@material-ui/core';
import {
    object, func, string, bool, shape,
} from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import DateOfBirthContainer from './DateOfBirthContainer';
import { getIsProductFilterZipcodeValid } from '../../../../../../../state/ducks/App/App-Selectors';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { resetProductFilterZipcodeValidity } from '../../../../../../../state/ducks/App/App-Actions';

const styles = (theme) => ({
    addonBox: {
        '& .age-verification': {
            position: 'relative',
        },
        '& .age-verification::after': {
            left: 28,
            top: -10,
        },
        '& .zip-code-box': {
            paddingTop: 0,
        },
    },
    icon: {
        color: theme.palette.colorIconHeader,
        height: '40px',
        textAlign: 'right',
    },
    topContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    main: {
        width: '633px',
        height: '230px',
        margin: '0px 0px 18px 0px',
    },
    cardTitleZipCode: {
        fontSize: '16px',
        fontWeight: '700',
    },
    verificationContainer: {
        display: 'block !important',
    },
    zipcode: {
        width: '100%',
        '& .MuiFormLabel-filled': {
            transform: 'translate(14px, 9px) scale(0.75)',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            transform: 'translate(14px, 9px) scale(0.75)',
        },
        '& .zip-code-error': {
            '&::before': {
                top: 0,
            },
        },
    },
    form: {
        width: '100%',
        margin: '16px 0px 0px 0px !important',
        '& .MuiButton-root.Mui-disabled': {
            backgroundColor: theme.palette.cms?.grey || '#b9b8b8',
            color: theme.palette.cms?.white || '#ffffff',
            border: 'inherit',
        },
    },

    zipField: {
        textAlign: 'center',
        width: '100%',
        '& .MuiInputBase-root': {
            backgroundColor: theme.palette.cms?.white || '#ffffff',
            boxShadow: ' 0 0 0 1px #C4C4C4',
            borderRadius: '5px',
            '&::before': {
                content: 'inherit',
            },
            '&::after': {
                content: 'inherit',
            },
            '& input': {
                padding: '27px 12px 8px !important',
                fontWeight: 100,
            },
        },
        '& .MuiInputLabel-filled': {
            fontSize: '16px',
            color: '#000000',
            fontWeight: 100,
        },
        '& .MuiFormLabel-root.Mui-focused': {
            fontSize: '12px',
            color: '#555',
        },
        '& .MuiFormLabel-filled': {
            fontSize: '12px',
            color: '#555',
        },
    },
    additionalCompliance: {
        backgroundColor: theme.palette.cms?.additionalComplianceColor || '#f9f6f6',
        color: theme.palette.black || '#1f1f1b',
        padding: '5px',
        fontSize: '0.8em',
        lineHeight: '1.4em',
        '& p': {
            margin: '10px',
        },
    },
    complianceLink: {
        color: theme.palette.black || '#1f1f1b',
        background: 'transparent',
        border: '0',
        padding: '0',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    dialogMain: {
        position: 'relative',
    },
    wineContainer: {
        padding: '0 10px',
        fontSize: '0.8em',
        minHeight: '120px',
        minWidth: '300px',
        '& h4': {
            fontSize: '1.2em',
        },
        '& h5': {
            fontSize: '1em',
        },
        '& h6': {
            fontSize: '1em',
        },
    },
    wineHeader: {
        display: 'inline-block',
    },
    wineHeaderClose: {
        display: 'inline-block',
        right: '10px',
        top: '3px',
        position: 'absolute',
        backgroundColor: theme.palette.white || '#ffffff',
        cursor: 'pointer',
    },
    zipSubmitButton: {
        backgroundColor: theme.palette.primary.main || '#2F2F2F',
        color: theme.palette.cms?.white || '#ffffff',
        minWidth: '100%',
        padding: '0px 15px',
        borderRadius: 'inherit',
        margin: '24px 0px',
        height: '55px',
        '&:hover': {
            backgroundColor: theme.palette.primary.main || '#2F2F2F',
        },
    },
    zipDisabledButton: {
        backgroundColor: theme.palette.cms?.white || '#ffffff',
        color: '#2F2F2F !important',
        minWidth: '100%',
        padding: '0px 15px',
        borderRadius: 'inherit',
        margin: '24px 0px',
        height: '55px',
        border: `1px solid ${theme.palette.primary.main || '#2F2F2F'}`,
        fontWeight: '600',

        '&:hover': {
            backgroundColor: theme.palette.primary.main || '#2F2F2F',
        },
    },
    zipCodeLink: {
        textDecoration: 'underline',
        fontWeight: 500,
        color: '#000000',
        fontSize: '18px',
        marginTop: '5px',
        display: 'block',
    },
    invalidZipError: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '12px',
        color: '#DF3030',
        marginTop: '4px',
        '&::before': {
            width: '16px',
            height: '16px',
            padding: '0px',
            fontSize: '12px',
            top: '3px',
            '@media screen and (max-width: 600px)': {
                top: 0,
            },
        },
        '@media screen and (max-width: 600px)': {
            marginTop: '5px',
        },
    },
    errorFields: {
        '& .MuiInputBase-root': {
            boxShadow: '0 0 0 1px #DF3030',
        },
    },
});

const AgeVerificationRecipientForm = ({
    classes,
    getBirthMonth,
    validateFields,
    birthMonth,
    monthErrorMessage,
    getBirthDay,
    birthDay,
    dayErrorMessage,
    getBirthYear,
    birthYear,
    yearErrorMessage,
    handleAgeVerification,
    handleZipChange,
    zipField,
    zipFieldRef,
    inlinePDPAddon,
    recipientDayErrorMessage,
    recipientYearErrorMessage,
    recipientBirthDay,
    recipientBirthMonth,
    recipientBirthYear,
    recipientMonthErrorMessage,
    stateValue,
    zipError,
    dobError,
    recipientDobError,
    productNotAvailableError,
    setDobError,
    setZipError,
    setRecipientDobError,
    setProductNotAvailableError,
}) => {
    const zipValid = useSelector(getIsProductFilterZipcodeValid);
    const dispatch = useDispatch();
    useEffect(() => {
        if (stateValue === 'HI' || stateValue === 'WI') {
            dispatch(trackEvent({
                eventCategory: 'Wine- HI/WI',
                eventAction: 'DOB Recipient Requirement',
                eventLabel: 'Age Verification Modal',
            }));
        }
    }, [stateValue]);

    useEffect(() => {
        if ((zipValid === false || !zipValid) && zipField?.length < 5) {
            dispatch(resetProductFilterZipcodeValidity());
        }
    }, [zipValid, zipField]);
    const zipCodeError = (zipValid === false && zipField?.length >= 5) || zipError || productNotAvailableError;
    const zipErrorMessage = zipError ? 'Enter a valid ZIP Code' : 'Invalid zip code';
    return (
        <div className={classes.mobileModal}>
            <div className={`verification-container ${classes.verificationContainer}`} data-testid="age-verification-model">

                <div className={`zip-code-box ${classes.zipcode}`}>
                    <p className={`zip-code-label ${classes.cardTitleZipCode}`}>
                        Confirm delivery ZIP code
                    </p>

                    <div className={classes.form} style={{ display: 'flex' }}>
                        <TextField
                            label="Destination ZIP Code *"
                            variant="filled"
                            type="tel"
                            id="zipcode-text-field"
                            name="zipcodeTextField"

                            onChange={(e) => {
                                handleZipChange(e, 'recipient');
                                setZipError(false);
                                setProductNotAvailableError(false);
                            }}
                            value={zipField}
                            inputRef={zipFieldRef}
                            inputProps={{
                                maxLength: 5,
                                'data-testid': 'zip-code-field',
                            }}
                            className={zipCodeError ? `${classes.errorFields} ${classes.zipField}` : classes.zipField}
                            InputLabelProps={{
                                shrink: false,
                            }}
                        />
                    </div>
                    {zipCodeError && <span className={`${classes.errorMessage} ${classes.invalidZipError}`}> {productNotAvailableError ? 'Not eligible for alcohol delivery'  : zipErrorMessage}</span>}
                </div>
                <div>
                    <DateOfBirthContainer
                        classes={classes}
                        getBirthMonth={getBirthMonth}
                        validateFields={validateFields}
                        birthMonth={birthMonth}
                        monthErrorMessage={monthErrorMessage}
                        getBirthDay={getBirthDay}
                        birthDay={birthDay}
                        dayErrorMessage={dayErrorMessage}
                        getBirthYear={getBirthYear}
                        birthYear={birthYear}
                        yearErrorMessage={yearErrorMessage}
                        handleAgeVerification={() => handleAgeVerification('')}
                        zipFieldRef={zipFieldRef}
                        inlinePDPAddon={inlinePDPAddon}
                        label="Confirm your age"
                        zipError={zipError}
                        dobErrorState={dobError}
                        setErrorState={setDobError}
                    />
                    {(stateValue === 'HI' || stateValue === 'WI') && zipField?.length >= 5 && (
                        <DateOfBirthContainer
                            classes={classes}
                            getBirthMonth={(e) => getBirthMonth(e, 'recipient')}
                            getBirthDay={(e) => getBirthDay(e, 'recipient')}
                            getBirthYear={(e) => getBirthYear(e, 'recipient')}
                            validateFields={(e) => validateFields(e, '', 'recipient')}
                            birthMonth={recipientBirthMonth}
                            birthDay={recipientBirthDay}
                            birthYear={recipientBirthYear}
                            monthErrorMessage={recipientMonthErrorMessage}
                            dayErrorMessage={recipientDayErrorMessage}
                            yearErrorMessage={recipientYearErrorMessage}
                            handleAgeVerification={() => handleAgeVerification('recipient')}
                            zipFieldRef={zipFieldRef}
                            inlinePDPAddon={inlinePDPAddon}
                            label="Confirm recipient’s age"
                            type="recipient"
                            dobErrorState={recipientDobError}
                            setErrorState={setRecipientDobError}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

AgeVerificationRecipientForm.defaultProps = {
    inlinePDPAddon: false,
    stateValue: '',
    zipError: false,
    dobError: false,
    recipientDobError: false,
    productNotAvailableError: false,
};
AgeVerificationRecipientForm.propTypes = {
    classes: object.isRequired,
    zipField: string.isRequired,
    birthDay: string.isRequired,
    birthMonth: string.isRequired,
    birthYear: string.isRequired,
    dayErrorMessage: string.isRequired,
    monthErrorMessage: string.isRequired,
    yearErrorMessage: string.isRequired,
    zipFieldRef: func.isRequired,
    getBirthDay: func.isRequired,
    getBirthMonth: func.isRequired,
    getBirthYear: func.isRequired,
    handleAgeVerification: func.isRequired,
    validateFields: func.isRequired,
    handleZipChange: func.isRequired,
    inlinePDPAddon: bool,
    recipientDayErrorMessage: string.isRequired,
    recipientYearErrorMessage: string.isRequired,
    recipientBirthDay: string.isRequired,
    recipientBirthMonth: string.isRequired,
    recipientBirthYear: string.isRequired,
    recipientMonthErrorMessage: string.isRequired,
    stateValue: string,
    zipError: bool,
    dobError: bool,
    recipientDobError: bool,
    productNotAvailableError: bool,
    setProductNotAvailableError: func.isRequired,
    setDobError: func.isRequired,
    setZipError: func.isRequired,
    setRecipientDobError: func.isRequired,
};

export default withStyles(styles)(AgeVerificationRecipientForm);
